import styled from "styled-components";

import BIX from "../img/BIX.svg";
import BIGongim from "../img/BIGongim.svg";
import BIYWM from "../img/BIYWM.svg";

const BottomFrame = styled.div`
  width: 100%;
  padding: 40px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  border-top: solid 1px #707070;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 36px 0px 0px 0px;
  }
`;

const LeftBI = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: 767px) {
    gap: 14px;
  }
`;

const BIImg = styled.img`
  height: 30px;
  @media (max-width: 767px) {
    height: 23px;
  }
`;

const BIXimg = styled.img`
  height: 14px;
  @media (max-width: 767px) {
    height: 10px;
  }
`;

const RightFrame = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 767px) {
    gap: 6px;
    padding: 6px 12px;
    background-color: #333;
    border-radius: 4px;
  }
`;

const RightText = styled.div`
  font-family: Gongim-Reguler;
  font-size: 20px;
  color: #333;
  @media (max-width: 767px) {
    font-size: 16px;
    color: #fff;
  }
`;

export default function Bottom() {
  return (
    <BottomFrame>
      <LeftBI>
        <BIImg src={BIGongim} />
        <BIXimg src={BIX} />
        <BIImg src={BIYWM} />
      </LeftBI>
      <RightFrame style={{ cursor: 'pointer' }} onClick={() => {document.location.href='tel:1599-7030'}}>
        <RightText>고객센터</RightText>
        <RightText>1599-7030</RightText>
      </RightFrame>
    </BottomFrame>
  );
}
